module.exports = __webpack_public_path__ + "static/media/mug-hot.82b9b87a.svg";